import type ModelAssignmentView from '@UI/Store/AiConfiguration/Views/ModelAssignmentView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `list` always holds one entry per `AiUsage` value, in enum declaration order, including unassigned
 * usages. `scopeId` names the resource at this level regardless of its type, same convention as
 * `AiProvidersListView.scopeId`; `scopeType` distinguishes which of the three assignment slots this
 * instance belongs to.
 */
class ModelAssignmentsListView {
	readonly list: readonly ModelAssignmentView[];
	readonly scopeId: number;
	readonly scopeType: 'account' | 'organization' | 'facility';

	constructor(
		list: readonly ModelAssignmentView[],
		scopeId: number,
		scopeType: 'account' | 'organization' | 'facility',
	) {
		this.list = list;
		this.scopeId = scopeId;
		this.scopeType = scopeType;

		Object.freeze(this);
	}

	/** Replaces the entry for `usage`, keeping the original order of the entries. */
	replaceUsage(usage: string, view: ModelAssignmentView): ModelAssignmentsListView {
		return new ModelAssignmentsListView(
			this.list.map((entry) => (entry.usage.value === usage ? view : entry)),
			this.scopeId,
			this.scopeType,
		);
	}
}

export default ModelAssignmentsListView;
